export default __webpack_public_path__ + "static/media/phone-call.e127e3fd.png";